import { Component, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { feedbackSubmit } from '../../model/feedbackSubmit';
import { FeedbackService } from '../../service/feedback.service';
import { TextService } from 'src/app/common/text.service';

@Component({
  selector: 'app-requestorfeedback',
  templateUrl: './requestor.feedback.component.html',
  styleUrls: ['./requestor.feedback.component.css']
})
export class RequestorFeedbackComponent {
  @ViewChild('feedbackForm', { static: false })
  feedbackForm!: NgForm;
  @Input() taskId: any;
  @Input() canComment = false;
  isListloading = false;
  errorMessage!: string;
  isError = false;
  feedbackSubmitted = false;
  submitFeedbackSubscription?: Subscription;
  feedBackData: feedbackSubmit = {
    comment: '',
    responseId: ''
  }
  init:any;
  constructor(private readonly feedbackService: FeedbackService,private readonly Init:TextService ) {
  }
  ngOnDestroy(): void {
    this.submitFeedbackSubscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.init = this.Init.getEditorInit();
  }
  onSubmit() {
    this.feedBackData.comment = this.feedbackForm.value.comment;
    this.feedBackData.responseId = (this.taskId);
    this.submitFeedback(this.feedBackData);
  }

  submitFeedback(feedbackdata: feedbackSubmit) {
    this.isListloading = true;
    this.feedbackSubmitted = true;
    this.feedbackService.submitFeedback(feedbackdata).subscribe({
      next: () => {
        this.feedbackService.feedbackEmitter.next(feedbackdata);
        this.isListloading = false;
        this.feedBackData.comment = '';
        this.feedbackForm.reset();
        this.feedbackSubmitted = false;
      },
      error: (err) => { this.isError = true; this.errorMessage = err.error; this.feedbackSubmitted = false; },
      complete: () => { this.feedbackSubmitted = false; }
    });
  }
}
